export const ApplicantSectionConstants = {
  PROFILE: 'Profile',
  INSTRUCTION: 'Instruction',
  CONTACT_DETAIL: 'ContactDetail',
  PERSONAL_INFORMATION: 'PersonalInformation',
  DISCLOSURE: 'Disclosure',
  FHP_HISTORY: 'FHPHistory',
  MILITARY: 'Military',
  EMPLOYMENT_HISTORY: 'EmploymentHistory',
  LAW_ENFORCEMENT_HISTORY: 'LawEnforcementHistory',
  SPOUSE: 'Spouse',
  EDUCATION: 'Education',
  DRIVING_HISTORY: 'DrivingHistory',
  DRUG_HISTORY: 'DrugHistory',
  LICENSE_HISTORY: 'LicenseHistory',
  ARREST_HISTORY: 'ArrestHistory',
  AFFILIATIONS: 'Affiliations',
  CHARACTER_REFERENCES: 'CharacterReferences',
  CREDIT_HISTORY: 'CreditHistory',
  RES_ADDR_HISTORY: 'ResAddrHistory',
  SOCIAL_MEDIA: 'SocialMedia',
  CERTIFICATIONS: 'Certifications',
  VETERAN_PREFERENCE: 'VeteranPreference',
  EEO: 'EEO',
  UNIFORM_SIZE: 'UniformSize',
}
